module.exports = __webpack_public_path__ + "static/media/You & Me This Morning _ 4-14-2015.f5a510ff.jpg";